import React from 'react'
import { Link } from 'react-scroll'

import { Button } from '../../common'

import './styles.scss'

const Main = ({ isLegalFlow, flow_type, flow_tag, cartoonifyImage }) => {
	const renderMainImage = () => {
		let flow = flow_type
		if (!cartoonifyImage && flow_tag === '33' && flow_type === '5') {
			flow = 'no photo'
		}

		switch (flow) {
			case '1':
			case '9':
			case 'no photo': {
				return (
					<>
						<img
							src="/images/sale/phone-frame.png"
							alt="lock"
							className="phone-frame"
						/>
						<div className="ad">
							<div className="lock-wrapper">
								<img src="/images/sale/lock.png" alt="lock" className="lock" />
							</div>
							<p className="ad-text-wrapper ">
								{flow === 'no photo'
									? 'Refine cartoonified your image – just take it!'
									: 'Refine brought you super -animation, just take it!'}
							</p>

							<Link
								to="price"
								smooth={true}
								duration={1000}
								spy={true}
								exact="true"
								offset={-100}
							>
								<Button buttonText="Unlock Results" onClick={() => {}} />
							</Link>
						</div>
						<img
							src="/images/sale/user-image.png"
							alt="user-image"
							className="user-image"
						/>
					</>
				)
			}
			case '2':
			case '10': {
				return (
					<>
						<img
							src="/images/sale/phone-frame.png"
							alt="lock"
							className="phone-frame"
						/>
						<video
							autoPlay="autoplay"
							loop
							muted
							src="/videos/sale/ad.mp4"
							type="video/mp4"
							className="ad-video"
							playsInline
						/>
					</>
				)
			}
			case '3': {
				return (
					<div className="display-prediction">
						<img
							src="/images/sale/pink-back.png"
							alt="pink flash"
							className="flash-image"
						/>
						<div className="prediction-corners">
							<video
								poster="/images/sale/brides.png"
								autoPlay="autoplay"
								loop
								muted
								src="/videos/sale/brides.mp4"
								type="video/mp4"
								className="prediction-video"
								playsInline
							/>
						</div>
					</div>
				)
			}
			case '4': {
				return (
					<div className="display-prediction" style={{ height: '300px' }}>
						<img
							src="/images/sale/pink-back.png"
							alt="pink flash"
							className="flash-image"
						/>
						<div className="prediction-corners" style={{ height: '300px' }}>
							<video
								poster="/images/sale/mother.png"
								autoPlay="autoplay"
								loop
								muted
								src="/videos/sale/mother.mp4"
								type="video/mp4"
								className="prediction-video"
								playsInline
								style={{ width: '335px', top: '0', right: '0' }}
							/>
						</div>
					</div>
				)
			}
			case '5':
			case '6': {
				return (
					<>
						<img
							src="/images/sale/phone-frame.png"
							alt="lock"
							className="phone-frame"
						/>
						<img
							id="cartoonify-image"
							src="/images/sale/cartoonify-image.png"
							alt="Example of what you can get with Refine."
							className="cartoonify-image"
						/>
					</>
				)
			}
			default: {
				return <p>Component now found</p>
			}
		}
	}

	const renderMainTitle = () => {
		switch (flow_type) {
			case '1':
			case '2':
			case '9':
			case '10': {
				return <h2 className="sale-screen-main__title">Modernize yourself!</h2>
			}
			case '3': {
				return (
					<h2 className="sale-screen-main__title prediction-title">
						In 3 years you&apos;ll start a family. Now think about
						career&hobbies.
					</h2>
				)
			}
			case '4': {
				return (
					<h2 className="sale-screen-main__title prediction-title">
						You will deliver a baby next year! You definitely have a clear
						vision of that!
					</h2>
				)
			}
			case '5':
			case '6': {
				return <h2 className="sale-screen-main__title">Cartoonify yourself!</h2>
			}
			default: {
				return <p>Component now found</p>
			}
		}
	}

	const renderMainText = () => {
		switch (flow_type) {
			case '1':
			case '2':
			case '9': {
				return `What else could be done with Refine App${
					isLegalFlow ? '(IOS, Android)' : ''
				}:`
			}
			case '3':
			case '4':
			case '5': {
				return `What else you can try with Refine app ${
					isLegalFlow ? '(IOS, Android)' : ''
				}:`
			}
			case '6': {
				return 'Our features help you express yourself and change photos originally'
			}
			case '10': {
				return `Our features help you express yourself and change photos originally ${
					isLegalFlow ? '(IOS, Android)' : ''
				}`
			}
			default: {
				return <p>Component now found</p>
			}
		}
	}

	return (
		<div className="sale-screen-main">
			{renderMainTitle()}
			<div className="main-image-wrapper">{renderMainImage()}</div>
			{flow_type === '5' || flow_type === '6' ? (
				<></>
			) : (
				<div className="main-winner">
					{!isLegalFlow && (
						<img
							src="/images/sale/apple-winner.png"
							alt="apple-winner"
							className="main-winner__image"
						/>
					)}
					<p className="main-winner__text">{renderMainText()}</p>
				</div>
			)}
		</div>
	)
}

export { Main }
